module.exports = __webpack_public_path__ + "static/media/youtube-dark.467877c9.svg";